import { Typography } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

const ProgressBar = (props: { progress: [number, number] | undefined; label: string }) => {
  // not started
  if (props.progress == null) {
    return null;
  } else {
    const percent = (100 * props.progress[0]) / props.progress[1];
    // completed
    if (percent >= 100) return null;

    return (
      <>
        <Typography variant="caption" gutterBottom>
          {props.label}
        </Typography>
        <LinearProgress variant="determinate" value={percent} />
      </>
    );
  }
};

export { ProgressBar };
